const state = {
    showTodo: false,
    competences: false,
    employees: false,
    certificate: false,
};

const mutations = {
    SET_SHOW_TODO: (state, value) => {
        state.showTodo = value;
    },
    SET_ONBOARDING_STEP: (state, key) => {
        state[key] = true;
    },
};

const actions = {
    //todo: add actions to check if a user already has completed a step when logging in
    //???: should this be done in the backend?
};

const getters = {
    GET_ONBOARDING_STEP: (state) => (key) => {
        return state[key];
    },
    GET_SHOW_TODO: (state) => {
        return state.showTodo;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
